import { render } from "./Comment.vue?vue&type=template&id=ad352cba"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"
script.render = render

export default script